export const { format } = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL'
})
